import CreditCard from './CreditCard.js';

export default CreditCard;
